import { render, staticRenderFns } from "./AtFacebookLogin.vue?vue&type=template&id=2127cdf2&scoped=true&"
import script from "./AtFacebookLogin.vue?vue&type=script&lang=js&"
export * from "./AtFacebookLogin.vue?vue&type=script&lang=js&"
import style0 from "./AtFacebookLogin.vue?vue&type=style&index=0&id=2127cdf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127cdf2",
  null
  
)

export default component.exports